import React from "react";
import ReactModal from "react-modal";

function ServiceItem({ number, title, desc, longDesc }) {
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }
  return (
    <li>
      <div className="list_inner" onClick={openModal}>
        <span className="number">{number}</span>
        <h3 className="title">{title}</h3>
        <p className="text">{desc}</p>
        <div className="tokyo_tm_read_more">
          <div className="read-more">
            <span>Read More</span>
          </div>
        </div>
      </div>
      <ReactModal
        className="mymodal"
        overlayClassName="myoverlay"
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal">
        <div className="tokyo_tm_modalbox_news">
          <button className="close-modal" onClick={closeModal}>
            <img
              src="https://tokyo-nextjs.vercel.app/img/svg/cancel.svg"
              alt="close icon"
            />
          </button>
          <div className="box_inner">
            <div className="description_wrap scrollable">
              <div className="details">
                <h3 className="title">{title}</h3>
              </div>
              <div className="main_content ">
                <div className="descriptions">
                  <p>{longDesc}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </li>
  );
}

export default ServiceItem;
